export const profile = {
  firstName: 'Avinash',
  lastName: 'Bandi',
  role: 'Full Stack Developer · Machine Learning Engineer',
  tagline:
    'I build intelligent web experiences — from pixel-perfect frontends to deep learning pipelines.',
  about:
    "I'm a passionate full-stack developer with expertise in creating innovative digital solutions. My journey in technology is driven by curiosity and a commitment to excellence — whether that's shipping production web apps or training computer vision models.",
  email: 'avinashbhargavbandi@gmail.com',
};

export const skills = [
  'Python',
  'AWS',
  'Django',
  'React',
  'MongoDB',
  'Machine Learning',
  'Deep Learning',
  'Computer Vision',
];

export const stats = [
  { value: '10+', label: 'Projects Completed' },
  { value: '1+', label: 'Years Experience' },
  { value: '2+', label: 'Happy Clients' },
];

export const projects = [
  {
    title: 'ATS with Google Gemini',
    description:
      'Application Tracking System with resume upload and job-description matching, powered by Google Gemini.',
    emoji: '📄',
    tech: ['Python', 'Streamlit', 'Google Gemini API'],
    accent: 'violet',
  },
  {
    title: 'Tokenizer Tool',
    description:
      'Advanced token counting and visualization tool for AI models, built on tiktoken.',
    emoji: '🔤',
    tech: ['React', 'tiktoken', 'JavaScript'],
    link: '/tokenizer',
    linkLabel: 'Try it out →',
    accent: 'cyan',
  },
];

export const socials = [
  { label: 'Email', icon: '📧', href: 'mailto:avinashbhargavbandi@gmail.com' },
  { label: 'LinkedIn', icon: '💼', href: 'https://www.linkedin.com/in/avinashbhargavbandi/' },
  { label: 'GitHub', icon: '🐙', href: 'https://github.com/AvinashBhargav' },
];
